module.exports = __webpack_public_path__ + "img/cloud-hosting.7fa7a56e.svg";